<template>
    <p>Please wait...</p>
</template>

<script>
    //import router from '@/router';
    import Oidc from 'oidc-client';
    import { getCurrentInstance } from 'vue';

    export default {
        mounted() {
            var mgr = new Oidc.UserManager({ userStore: new Oidc.WebStorageStateStore() });
            const globalProperties = getCurrentInstance()?.appContext?.config?.globalProperties;

            mgr.signinSilentCallback()
            .then(() =>{
                if (globalProperties && globalProperties.startSignalR) {
                    globalProperties.startSignalR();
                }
            });
        }
    };
</script>